(function(){

	if ( window.__swipeHintInit ) return;
	window.__swipeHintInit = true;

	function buildOverlay(slider){
		const overlay = document.createElement('div');
		overlay.className = 'css-slider-swipe-hint';
		overlay.setAttribute('aria-hidden', 'true');

		const dot = document.createElement('span');
		dot.className = 'css-slider-swipe-hint__dot';
		overlay.appendChild(dot);

		const text = slider.dataset.swipeHintText;
		if ( text ) {
			const pill = document.createElement('span');
			pill.className = 'css-slider-swipe-hint__pill';
			pill.textContent = text;
			overlay.appendChild(pill);
		}

		return overlay;
	}

	function play(slider){

		if ( ! slider.items || slider.items.length <= 1 ) return;

		const holder = slider.querySelector('.css-slider-holder');
		if ( ! holder ) return;

		const overlay = buildOverlay(slider);
		slider.appendChild(overlay);

		const rtl = document.documentElement.getAttribute('dir') == 'rtl';
		const startScroll = holder.scrollLeft;

		// Scroll-snap would otherwise fight the small peek scroll below.
		holder.classList.add('disable-snapping');

		setTimeout(()=>{
			overlay.classList.add('is-visible');
		}, 500);

		setTimeout(()=>{
			overlay.classList.add('is-panning');
			holder.scrollBy({ left: rtl ? -46 : 46, behavior: 'smooth' });
		}, 900);

		setTimeout(()=>{
			overlay.classList.remove('is-panning');
			holder.scrollTo({ left: startScroll, behavior: 'smooth' });
		}, 1600);

		setTimeout(()=>{
			overlay.classList.remove('is-visible');
			holder.classList.remove('disable-snapping');
		}, 2200);

		setTimeout(()=>{
			overlay.remove();
		}, 2600);

	}

	function watch(slider){
		if ( slider.sliderEnabled ) {
			play(slider);
		} else {
			slider.addEventListener('ready', ()=>play(slider), { once: true });
		}
	}

	function scan(){
		document.querySelectorAll('css-slider[data-swipe-hint]').forEach(watch);
	}

	// Exposed so an ajax swap (e.g. the PDP color switch) can replay the hint
	// on the freshly-inserted gallery, which this file's own DOMContentLoaded
	// scan can't reach since it only runs once for the initial page load.
	window.initSwipeHint = scan;

	if ( document.readyState === 'loading' ) {
		document.addEventListener('DOMContentLoaded', scan);
	} else {
		scan();
	}

})();
